import classnames from 'classnames/bind'
import ReactPlayer, { YouTubePlayerProps } from 'react-player/youtube'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type VideoPlayerYoutubeProps = YouTubePlayerProps

function VideoPlayerYoutube({
  className,
  hasPlaysInline,
  videoPaused,
  videoClassName,
  videoRef,
  onReadyFunc,
  onStartedFunc,
  onDurationChange,
  onEndedFunc,
  updateProgress,
  src,
  loop,
  isMuted,
  children,
  style,
  forwardRef,
  ...rest
}: VideoPlayerYoutubeProps) {
  return (
    <>
      <div className={className} style={style} ref={forwardRef}>
        <ReactPlayer
          ref={videoRef}
          url={src}
          className={cx(css.video, videoClassName)}
          playing={!videoPaused}
          width="100%"
          height="100%"
          onStart={onStartedFunc}
          progressInterval={20}
          onDuration={onDurationChange}
          onEnded={onEndedFunc}
          onProgress={updateProgress}
          onReady={onReadyFunc}
          muted={isMuted}
          playsinline={hasPlaysInline}
          loop={loop}
          volume={isMuted ? 0 : 1}
          config={{
            playerVars: { modestbranding: 1, rel: 0, controls: 0, showinfo: 0 },
          }}
          {...rest}
        />
      </div>

      {children}
    </>
  )
}

VideoPlayerYoutube.defaultProps = {
  hasPlaysInline: false,
  isMuted: false,
  loop: false,
}

export default VideoPlayerYoutube
